import React from 'react';

const TabContext = React.createContext({ isActiveTab: true } as TabContextType);
export default TabContext;

type TabContextType = {
  tabId?: string;
  isActiveTab: boolean;
};
